// extracted by mini-css-extract-plugin
export default {"butt":"FooterButton_butt__dtEAo","block":"FooterButton_block__e1AMu"};